import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAmbarAgreementRequest } from '../models/request/ambarAgreement/AddAmbarAgreementRequest';
import { GetAmbarAgreementListPagingAndFilterRequest } from '../models/request/ambarAgreement/GetAmbarAgreementListPagingAndFilterRequest';

export class AmbarAgreementService {
    /** Anlaşma listesindeki şablon alanı kolonunda kullanılmış farklı değerler (filtre seçenekleri). */
    static async getAmbarAgreementFieldValues(_fieldName: string) {
        try {
            var inputObj = {
                fieldName: _fieldName
            };

            console.log('SERVICE CALL - GetAmbarAgreementFieldValues', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreement/GetAmbarAgreementFieldValues', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarAgreementList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getAmbarAgreementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreement/getAmbarAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAmbarAgreementList(inputObj: GetAmbarAgreementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAmbarAgreementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreement/exportAmbarAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarAgreementListPagingAndFilter(inputObj: GetAmbarAgreementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAmbarAgreementListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreement/GetAmbarAgreementListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addAmbarAgreement(inputObj: AddAmbarAgreementRequest) {
        try {
            console.log('SERVICE CALL - AddAmbarAgreement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreement/AddAmbarAgreement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAmbarAgreement(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAmbarAgreement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreement/deleteAmbarAgreement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarAgreementById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAmbarAgreementById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreement/getAmbarAgreementById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}